import { ColumnData } from 'ui/tableHeader';
import { displayDateWithTodayAndYesterdayPrefix } from 'utils/date';
import {
  NAME_COLUMN_VALUE,
  STATUS_COLUMN_VALUE,
  TYPE_COLUMN_VALUE,
  LAST_MODIFIED_COLUMN_VALUE,
  LAST_USED_COLUMN_VALUE,
  API_KEYS_ACTIONS,
} from '../constants';
import { ApiKey } from '../types';

const COLUMN_DEFAULTS = {
  align: 'flex-start',
  sortable: true,
};

export const columns = [
  ...[
    {
      value: NAME_COLUMN_VALUE,
      name: 'Name',
    },
    {
      value: STATUS_COLUMN_VALUE,
      name: 'Status',
    },
    {
      value: TYPE_COLUMN_VALUE,
      name: 'Type',
    },
    {
      value: LAST_MODIFIED_COLUMN_VALUE,
      name: 'Last Modified',
    },
    {
      value: LAST_USED_COLUMN_VALUE,
      name: 'Last Used',
    },
  ].map((col) => ({ ...col, ...COLUMN_DEFAULTS })),
  {
    value: API_KEYS_ACTIONS,
    name: '',
    sortable: false,
    width: 80,
  },
] as ColumnData[];

export const createRows = (keys: ApiKey[]) =>
  keys.map((key) => ({
    ...key,
    id: key.keyHash,
    lastUsedAt: key[LAST_USED_COLUMN_VALUE]
      ? displayDateWithTodayAndYesterdayPrefix(key[LAST_USED_COLUMN_VALUE])
      : 'Unknown',
  }));
